import { CaseDataType } from "DataTypes/Case.type";
import { CheckNumber, CheckStringEmpty } from "Utils/Common";

export const formateCaseData: (data: any) => CaseDataType = (data) => {
  return {
    pkCase: CheckNumber(data?.pkCase),
    clientId: CheckNumber(data?.clientId),
    clientFullName: CheckStringEmpty(data?.clientFullName),
    caseTypeId: CheckNumber(data?.caseTypeId),
    caseTypeName: CheckStringEmpty(data?.caseTypeName),
    orderTypeId: CheckNumber(data?.orderTypeId),
    orderTypeName: CheckStringEmpty(data?.orderTypeName),
    casePrice: CheckNumber(data?.casePrice),
    paymentId: CheckNumber(data?.paymentId),
    currentProcessingStatusId: CheckNumber(data?.currentProcessingStatusId),
    currentProcessingStatusName: CheckStringEmpty(
      data?.currentProcessingStatusName
    ),
    description: CheckStringEmpty(data?.description),
    dateCreated: CheckStringEmpty(data?.dateCreated),
    dateUpdated: CheckStringEmpty(data?.dateUpdated),
    statusLastUpdated: CheckStringEmpty(data?.statusLastUpdated),
    createdByUserId: CheckNumber(data?.createdByUserId),
    createdByUserName: CheckStringEmpty(data?.createdByUserName),
    updatedByUserId: CheckNumber(data?.updatedByUserId),
    updatedByUserName: CheckNumber(data?.updatedByUserName),
    assignedProfessionalId: CheckNumber(data?.assignedProfessionalId),
    assignedProfessionalName: CheckNumber(data?.assignedProfessionalName),
  };
};
